module.exports = __webpack_public_path__ + "assets/img/18_1831_big.cd56fd77.jpg";